export const types = {
    TRIGGERSTATIC: 'TRIGGER-STATIC',
    ACTIVEDIRECTORY: 'ACTIVE-DIRECTORY',
    AUTOMS: 'AUTOMS',
    DATABASE: 'DATABASE',
    EXCEL: 'EXCEL',
    WORD: 'WORD',
    REPEAT: 'REPEATABLE',
    RESTFUL: 'RESTFUL-WEB-SERVICE',
    TIME: 'TIME-MANAGEMENT',
    CONDITION: 'CONDITION',
    STRING: 'STRING',
    DATATABLE: 'DATA-TABLE',
    DICTIONARY: 'DICTIONARY',
    ARRAY: 'ARRAY',
    SERVICEDESK: 'SERVICE-DESK-PLUS',
    RECORDER: 'RECORDER',
    DISPLAYMESSAGE: 'DISPLAY-MESSAGE',
    FILE: "FILE",
    PDF: 'PDF',
    FOLDER: 'FOLDER',
    NUMBER: 'NUMBER',
    OCR: 'OCR',
    EWS: 'EWS',
    EMAIL: 'EMAIL',
    DATA: 'DATA',
    PREPROCESSING: 'PRE-PROCESSING',
    MODELS: 'MODELS',
    ENDPOINT: 'ENDPOINT',
    DESKTOPACTIONS: 'DESKTOP-ACTIONS',
    STOP: 'STOP',
    GROUPING: 'GROUPING',
    PYTHON: 'PYTHON',
    JAVASCRIPT: 'JAVASCRIPT',
    POWERSHELL: 'POWERSHELL',
    OBJECT: 'OBJECT',
    CSVTEXT: 'CSV-TEXT',
    DATE: 'DATE',
    ADVANCEDACTIONS: 'ADVANCED-ACTIONS',
    WHATSAPP: 'WHATSAPP'
};
